function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Rectangle 2 Copy 24");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M509,78.392245 L509,245 L344.401697,245 C338.878849,245 334.401697,240.522847 334.401697,235 C334.401697,232.370202 335.437617,229.846252 337.285119,227.974736 L491.883423,71.3669814 C495.763369,67.4366043 502.094887,67.3957218 506.025264,71.2756678 C507.928625,73.1546073 509,75.7176983 509,78.392245 Z",
  id: "path-1"
}), React.createElement("filter", {
  x: "-25.8%",
  y: "-25.5%",
  width: "151.5%",
  height: "151.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 15,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Welcome",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Landing-main-Page",
  transform: "translate(-1097.000000, -350.000000)"
}, React.createElement("g", {
  id: "Hero",
  transform: "translate(140.000000, 220.000000)"
}, React.createElement("g", {
  id: "Hero-Graphic",
  transform: "translate(651.000000, 90.000000)"
}, React.createElement("g", {
  id: "Rectangle-2-Copy-24"
}, React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-2)",
  xlinkHref: "#path-1"
}), React.createElement("use", {
  fill: "#FFFFFF",
  fillRule: "evenodd",
  xlinkHref: "#path-1"
}))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "233px",
    height: "235px",
    viewBox: "0 0 233 235",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/round-triangle.4141fa45.svg";
export { SvgComponent as ReactComponent };